import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NbTagComponent } from '@nebular/theme';

@Component({
  selector: 'app-tag-list',
  templateUrl: './tag-list.component.html',
  styleUrls: ['./tag-list.component.scss'],
})
export class TagListComponent {
  @Input() tagList: any = [];
  @Input() removable: boolean = true;
  @Input() size: string = 'small';
  @Input() status: string = 'primary';
  @Input() optionsLimit: number = 0;
  @Input() showEllipsedTags: boolean = false;
  @Input() showCombinedText: boolean = false;
  tagListToRender: any = [];

  @Output() tagRemove = new EventEmitter<NbTagComponent>();

  onRemoveClick(event, option) {
    this.tagRemove.emit(option);
  }
}
